import { AccommodationType } from '../ngrx-store/app.state'

/**
 * The public link to an accommodation - what Share copies and what a chat about it starts with (the
 * delete warning finds chats about it by this link).
 */
export function accommodationUrl(accommodation: Pick<AccommodationType, 'id' | 'slug_id'>): string {
  return `${window.location.origin}/a/${accommodation.slug_id ?? accommodation.id}`
}

/** 'Self contain' however it was saved ('self contain', 'SELF CONTAIN') - types are saved as typed. */
export function accommodationTypeLabel(type: string | null | undefined): string {
  const lower = type?.trim().toLowerCase()
  return lower ? lower.charAt(0).toUpperCase() + lower.slice(1) : 'Accommodation'
}

/** '/year' after the rent. */
export function rentIntervalLabel(interval: string | null | undefined): string {
  switch (interval) {
    case 'monthly':
      return '/month'
    case 'quarterly':
      return '/quarter'
    case 'yearly':
      return '/year'
    default:
      return ''
  }
}

/** What the posting form's "status" choice says (create-new-accommodation). */
export function accommodationStatusLabel(status: string | null | undefined): string | undefined {
  switch (status) {
    case 'new_rent':
      return 'New rent - no one living there'
    case 'seeking_roommate':
      return 'Seeking a roommate'
    case 'active_rent':
      return 'Subletting an active rent'
    default:
      return undefined
  }
}
